import Banner from '@/components/banners/banner';
import Sections from '@/components/layouts/sections';
import type { HomePageProps } from '@/types';

export default function MinimalLayout({ variables }: HomePageProps) {
  return (
    <>
      <Banner />

      <Sections variables={variables.categories} />

      <section className="bg-accent px-4 py-12 text-justify text-light">
        <div className="container mx-auto max-w-7xl">
          <div className="flex flex-col items-start justify-between space-y-8 md:flex-row md:space-x-8 md:space-y-0 lg:space-x-12">
            <div className="flex flex-col items-start">
              <div className="mb-4">
                <svg
                  className="h-10 w-10 text-white"
                  fill="none"
                  viewBox="0 0 40 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.0002 36.6668C29.2049 36.6668 36.6668 29.2049 36.6668 20.0002C36.6668 10.7954 29.2049 3.3335 20.0002 3.3335C10.7954 3.3335 3.3335 10.7954 3.3335 20.0002C3.3335 29.2049 10.7954 36.6668 20.0002 36.6668Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M20 10V20L26.6667 23.3333"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </svg>
              </div>
              <h3 className="mb-2 text-xl font-semibold">Quick delivery now</h3>
              <p className="text-sm">
                Get your order delivered to your doorstep at the earliest from
                FreshCart pickup stores near you.
              </p>
            </div>

            <div className="flex flex-col items-start">
              <div className="mb-4">
                <svg
                  className="h-10 w-10 text-white"
                  fill="none"
                  viewBox="0 0 40 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M33.3332 20V36.6667H6.6665V20"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M36.6668 11.6665H3.3335V19.9998H36.6668V11.6665Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M20 36.6665V11.6665"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M20.0002 11.6668H12.5002C11.3951 11.6668 10.3353 11.2278 9.55388 10.4464C8.77248 9.66504 8.3335 8.60523 8.3335 7.50016C8.3335 6.39509 8.77248 5.33529 9.55388 4.55388C10.3353 3.77248 11.3951 3.3335 12.5002 3.3335C18.3335 3.3335 20.0002 11.6668 20.0002 11.6668Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M20 11.6668H27.5C28.6051 11.6668 29.6649 11.2278 30.4463 10.4464C31.2277 9.66504 31.6667 8.60523 31.6667 7.50016C31.6667 6.39509 31.2277 5.33529 30.4463 4.55388C29.6649 3.77248 28.6051 3.3335 27.5 3.3335C21.6667 3.3335 20 11.6668 20 11.6668Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </svg>
              </div>
              <h3 className="mb-2 text-xl font-semibold">
                Best Prices &amp; Offers
              </h3>
              <p className="text-sm">
                Cheaper prices than your local supermarket, great cashback
                offers to top it off. Get best prices &amp; offers.
              </p>
            </div>

            <div className="flex flex-col items-start">
              <div className="mb-4">
                <svg
                  className="h-10 w-10 text-white"
                  fill="none"
                  viewBox="0 0 40 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.5 15.6666L12.5 7.0166"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M35 26.6668V13.3335C34.9994 12.749 34.8451 12.1748 34.5526 11.6688C34.26 11.1627 33.8396 10.7424 33.3333 10.4502L21.6667 3.7835C21.1599 3.49093 20.5851 3.33691 20 3.33691C19.4149 3.33691 18.8401 3.49093 18.3333 3.7835L6.66667 10.4502C6.16044 10.7424 5.73997 11.1627 5.44744 11.6688C5.1549 12.1748 5.0006 12.749 5 13.3335V26.6668C5.0006 27.2514 5.1549 27.8255 5.44744 28.3316C5.73997 28.8376 6.16044 29.2579 6.66667 29.5502L18.3333 36.2168C18.8401 36.5094 19.4149 36.6634 20 36.6634C20.5851 36.6634 21.1599 36.5094 21.6667 36.2168L33.3333 29.5502C33.8396 29.2579 34.26 28.8376 34.5526 28.3316C34.8451 27.8255 34.9994 27.2514 35 26.6668Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M5.4502 11.6001L20.0002 20.0168L34.5502 11.6001"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M20 36.8V20"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </svg>
              </div>
              <h3 className="mb-2 text-xl font-semibold">Wide Assortment</h3>
              <p className="text-sm">
                Choose from 5000+ products across food, personal care,
                household, bakery, veg and non-veg &amp; other categories.
              </p>
            </div>

            <div className="flex flex-col items-start">
              <div className="mb-4">
                <svg
                  className="h-10 w-10 text-white"
                  fill="none"
                  viewBox="0 0 40 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M38.3335 6.6665V16.6665H28.3335"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M1.6665 33.3335V23.3335H11.6665"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                  <path
                    d="M5.84984 15C6.69512 12.6113 8.13173 10.4756 10.0256 8.79233C11.9195 7.10902 14.2089 5.9329 16.6803 5.37373C19.1517 4.81455 21.7244 4.89053 24.1585 5.59459C26.5925 6.29864 28.8086 7.60782 30.5998 9.39996L38.3332 16.6666M1.6665 23.3333L9.39984 30.6C11.1911 32.3921 13.4071 33.7013 15.8412 34.4053C18.2752 35.1094 20.848 35.1854 23.3194 34.6262C25.7907 34.067 28.0802 32.8909 29.9741 31.2076C31.8679 29.5243 33.3046 27.3887 34.1498 25"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </svg>
              </div>
              <h3 className="mb-2 text-xl font-semibold">Easy Returns</h3>
              <p className="text-sm">
                Not satisfied with a product? Return it at the doorstep &amp;
                get a refund within hours. No questions asked policy .
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
